import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { Translate } from '../../../../shared/LanguageService';
import { Resolution } from './Entities';

interface IZipLinkButtonMenu {
    onDownload: (resolution: Resolution) => void;
    anchorEl: HTMLElement | null;
    open: boolean;
    onOpen: (event: React.MouseEvent<HTMLElement>) => void;
    onClose: () => void;
}

const ZipLinkButtonMenu: React.FC<IZipLinkButtonMenu> = ({
    onDownload,
    anchorEl,
    open,
    onOpen,
    onClose
}) => {
    return (
        <>
            <Button
                variant="contained"
                onClick={onOpen}
                sx={{
                    backgroundColor: '#8fa39c',
                    borderRadius: '1px',
                    boxShadow: 'none',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    fontWeight: 'normal',
                    color: '#fff',
                    textTransform: 'none',
                    padding: '6px 16px',
                    '&:hover': {
                        backgroundColor: '#738c83',
                        boxShadow: 'none'
                    }
                }}
            >
                {Translate('image-processing/button-label/zip-download-link')}
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
                <MenuItem onClick={() => onDownload(Resolution.Normal)}>
                    {Translate('image-processing/button-label/zip-download-link/normal-resolution')}
                </MenuItem>
                <MenuItem onClick={() => onDownload(Resolution.High)}>
                    {Translate('image-processing/button-label/zip-download-link/high-resolution')}
                </MenuItem>
            </Menu>
        </>
    );
};

export default ZipLinkButtonMenu;
